import {
	isUndefinedOrNullOrEmpty,
	isString,
	isObject,
	isArray
} from './inspect';
import { hasOwnProperty, keys as objKeys } from './object';
import { createPatch } from 'rfc6902';
import _ from 'lodash';

/**
 *
 * @param {*} obj
 * @param {*} keys
 */
export const hasKeys = (obj, keys) => {
	if (!isObject(obj) || isUndefinedOrNullOrEmpty(keys) || keys.length == 0) {
		// console.warn(
		// 	`[Internal warn]:  "(obj, keys)" parameters are required.\n`
		// );
		return false;
	}
	if (isString(keys)) {
		if (!hasOwnProperty(obj, keys)) {
			// msg(keys);
			// obj = null;
			return false;
		}
	} else {
		for (let index = 0; index < keys.length; index++) {
			if (!hasOwnProperty(obj, keys[index])) {
				// msg(keys[index]);
				// obj = null;
				// break;
				return false;
			}
		}
	}
	// let msg = val =>
	// 	console.warn(`[Internal warn]: "${val}" property does not exist.\n`);

	return true;
};

/**
 *
 * @param {*} key
 * @param {*} fallback
 */
export const getEnv = (key, fallback = null) => {
	const env =
		typeof process !== 'undefined' && process ? process.env || {} : {};
	if (!key) {
		return env;
	}
	return env[key] || fallback;
};

/**
 *
 * @param {*} totalItems (required) - the total number of items to be paged
 * @param {*} currentPage  (optional) - the current active page, defaults to the first page
 * @param {*} pageSize (optional) - the number of items per page, defaults to 20
 * @param {*} maxPages  (optional) - the maximum number of page navigation links to display, defaults to 100
 * ref: https://jasonwatmore.com/post/2018/08/07/javascript-pure-pagination-logic-in-vanilla-js-typescript
 */
export const paginate = (totalItems, currentPage, pageSize, maxPages) => {
	// calculate total pages
	let totalPages = Math.ceil(totalItems / pageSize);

	// ensure current page isn't out of range
	if (currentPage < 1) {
		currentPage = 1;
	} else if (currentPage > totalPages) {
		currentPage = totalPages;
	}

	let startPage, endPage;
	if (totalPages <= maxPages) {
		// total pages less than max so show all pages
		startPage = 1;
		endPage = totalPages;
	} else {
		// total pages more than max so calculate start and end pages
		let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
		let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
		if (currentPage <= maxPagesBeforeCurrentPage) {
			// current page near the start
			startPage = 1;
			endPage = maxPages;
		} else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
			// current page near the end
			startPage = totalPages - maxPages + 1;
			endPage = totalPages;
		} else {
			// current page somewhere in the middle
			startPage = currentPage - maxPagesBeforeCurrentPage;
			endPage = currentPage + maxPagesAfterCurrentPage;
		}
	}

	// calculate start and end item indexes
	let startIndex = (currentPage - 1) * pageSize;
	let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

	// create an array of pages to ng-repeat in the pager control
	let pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
		i => startPage + i
	);

	// return object with all pager properties required by the view
	return {
		totalCount: totalItems,
		currentPage: currentPage,
		pageSize: pageSize,
		totalPages: totalPages,
		startPage: startPage,
		endPage: endPage,
		startIndex: startIndex,
		endIndex: endIndex,
		pages: pages
	};
};

/**
 *
 * @param {*} data
 * @param {*} filter
 * @param {*} sort
 */
export const filterAndSortArray = (data, filter, sort) => {
	if (!isArray(data) || !isObject(filter)) {
		return data;
	}

	const compare = r => l =>
		typeof l === 'object'
			? contains(r)(l)
			: typeof l === 'boolean'
			? l === r
			: l.toLowerCase().includes(r);

	const contains = r => l =>
		Object.keys(r).every(k => hasOwnProperty(l, k) && compare(r[k])(l[k]));

	let matches = data.filter(contains(filter));

	if (isObject(sort)) {
		const sortArr = Object.entries(sort).map(([key, value]) => {
			return {
				prop: key,
				direction: value === 'desc' ? -1 : 1
			};
		});

		matches = matches.sort((a, b) => {
			let i = 0;
			let result = 0;

			while (i < sortArr.length && result === 0) {
				result =
					sortArr[i].direction *
					(a[sortArr[i].prop].toString() <
					b[sortArr[i].prop].toString()
						? -1
						: a[sortArr[i].prop].toString() >
						  b[sortArr[i].prop].toString()
						? 1
						: 0);
				i++;
			}
			return result;
		});
	}

	return matches;
};

/**
 * Sorting a numerically asc array
 * @param {*} array
 *
 *
 */
export const numericSortingArray = array => {
	let done = false;
	while (!done) {
		done = true;
		for (let i = 1; i < array.length; i += 1) {
			if (array[i - 1] > array[i]) {
				done = false;
				let tmp = array[i - 1];
				array[i - 1] = array[i];
				array[i] = tmp;
			}
		}
	}
	return array;
};

export const timeDifference = (date1, date2, result) => {
	const days = date2.diff(date1, 'days');
	const months = date2.diff(date1, 'months');
	const years = date2.diff(date1, 'years');

	if (years > 0) {
		result =
			years === 1
				? years + 'Year and ' + months + 'Months ago'
				: years + 'Years and ' + months + 'Months ago';
	} else if (months >= 1) {
		result = months === 1 ? months + ' Month ago' : months + ' Months ago';
	} else if (days >= 7) {
		let weeks = Math.floor(days / 7);
		let restofDays = Math.floor(days % 7);
		let str =
			restofDays > 0
				? ' and ' + restofDays + restofDays === 1
					? 'day ago'
					: 'days ago'
				: 'ago.';
		result = weeks > 1 ? weeks + ' Weeks ' + str : weeks + ' Week ' + str;
	} else {
		result =
			days === 0
				? 'Today'
				: days === 1
				? days + ' day ago'
				: days + ' days ago';
	}
	return result;
};

export const generatePath = (pathName, obj, defaults) => {
	pathName = pathName || '';
	obj = obj || {};
	const path =
		`${pathName}/` +
		objKeys(defaults)
			.map(
				key =>
					key +
					'-' +
					(obj[key] === undefined || obj[key] === null
						? ''
						: obj[key])
			)
			.join('/');

	return path;
};

/**
 * Generate a random number
 * @param {*} min
 * @param {*} max
 * @returns
 */
export const generateRandomNumber = (min, max) => {
	if (!min) min = 1;
	if (!max) max = 10;

	return Math.floor(Math.random() * (max - min)) + min;
};

/**
 * Generate an array with step
 * @param {*} start
 * @param {*} stop
 * @param {*} step
 * @returns
 */
export const generateArray = (start, stop, step) => {
	if (!step) step = 1;

	return Array.from(
		{ length: (stop - start) / step + 1 },
		(_, i) => start + i * step
	);

	/* Usage
	//Generate array of numbers
	generateArray(1, 5, 1); 
	//result: [1, 2, 3, 4, 5]

	//Generate array of objects
	generateArray(1, 100, 1).map(x => {
		return {
			id: x
		};
	});
	//result: [{ id: 1 }, ..., { id: 100 }]
	*/
};

export const alphaString =
	'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
export const digitString = '1234567890';
export const symbolString = '!#$%^&*(){[}]?`~';

export const generateRandomString = (type, length) => {
	// let result = 'Math.random()
	// 	.toString(20)
	// 	.substr(2, length);

	let result = '';
	let characters = '';
	switch (type) {
		case 'digit':
			characters = digitString;
			break;
		case 'symbol':
			characters = digitString;
			break;
		case 'all':
			characters = alphaString + digitString + symbolString;
			break;
		default:
			characters = alphaString;
			break;
	}

	for (var i = 0; i < characters.length; i++) {
		result += characters.charAt(
			Math.floor(Math.random() * characters.length)
		);
	}
	return result.substr(2, length);
};

export const isAuthorized = (
	permissionsByUser,
	oidcUser,
	authorized = false
) => {
	const userPermissions = (oidcUser && oidcUser.SupportPermission) || [];
	authorized = permissionsByUser.every(r => userPermissions.includes(r));
	return authorized;
};

/**
 *
 * @param {*} obj
 * @returns
 */
export const serializeValues = (obj, defaults) => {
	let parameters = { ...obj };

	const keys = objKeys(parameters);
	if (keys.length === 0) {
		Object.assign(parameters, defaults);
	} else {
		const defaultKeys = objKeys(defaults);
		keys.forEach(key => {
			if (!defaultKeys.includes(key)) {
				delete parameters[key];
				return;
			}

			if (parameters[key] === undefined && defaults[key] !== undefined) {
				parameters[key] = defaults[key];
			} else {
				parameters[key] = parseValue(parameters[key]);
			}
		});
	}

	return parameters;
};

/**
 * Parse route path to object
 * @param {*} parameters
 */
export const parseRoutePath = route => {
	let path = route.fullPath;

	//just matches the route but has no parameters
	const currentKeys = objKeys(route.params);
	if (currentKeys.length === 1 && currentKeys[0] === 'pathParam') {
		path = route.params.pathParam;
		delete route.params.pathParam;
	}

	let params = {};

	path.split('?')[0]
		.split('/')
		.map(p => {
			if (p.match(/((\w)+-(\w)+)(\/(\w)+-(\w)+)*/)) {
				const kv = p.split('-');
				params[kv[0]] = parseValue(p.replace(`${kv[0]}-`, ''));
			}
		});

	Object.assign(route.params, params);
};

/**
 * Parse string to default
 * @param {*} val
 * @returns
 */
export const parseValue = str => {
	if (str == undefined || str == null || str === 'undefined') {
		return '';
	}

	//sanitize
	str = str.toString().trim();

	//boolean
	if (['true', 'false'].indexOf(str) >= 0) {
		return str.toLowerCase() === 'true';
	}

	//guid
	let regex = {
		3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
		4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
		5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
		all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	const pattern = regex['all'];
	if (str.toUpperCase().match(pattern)) {
		return str;
	}

	//int
	regex = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	if (str.match(regex)) {
		const parsed = Number.parseInt(str);
		if (!Number.isNaN(parsed)) {
			return parsed;
		}
	}

	return str;
};

/**
 * Group by array by field
 * @param {*} list
 * @param {*} fieldName
 * @returns
 */
export const groupBy = (list, fieldName) => {
	return list.reduce((result, item) => {
		(result[item[fieldName]] = result[item[fieldName]] || []).push(item);
		return result;
	}, {});
};

export const getPrintType = str => {
	if (str == 'I') return 'Impact';
	else if (str == 'L') return 'Laser';
	else return 'Default';
};

export const getStatusDescription = active => {
	if (active) return 'Active';
	else return 'Inactive';
};

export const copyToClipboard = str => {
	var el = document.createElement('textarea');
	document.body.appendChild(el);
	el.value = str;
	el.setAttribute('type', 'text');
	el.select();
	document.execCommand('copy');
	el.remove();
};

export const getNextNumber = (arr, isNegative) => {
	if (!(arr && arr.length)) {
		return isNegative ? -1 : 1;
	}
	let val = 0;

	if (isNegative) {
		val = Math.min(...arr);
		return val > 0 ? -1 : val - 1;
	}

	val = Math.max(...arr);
	return val > 0 ? val + 1 : 1;
};

/**
 * Generate a date by number
 * @param Number days
 * @returns Date
 */
export const getMinMaxDataTime = days => {
	let result = new Date();

	if (days && days !== 0) {
		let previous = new Date(result);

		previous.setDate(previous.getDate() + days);

		result = previous;
	}

	return encodeURIComponent(result.toLocaleDateString());
};

/**
 * check if only the permission exists in the group
 * @param {string} groupName
 * @param {string} permission
 * @returns
 */
export const hasPermissionByGroupName = (groupName, permission, user) => {
	const userPermissions = (user && user.SupportPermission) || [];

	let groupByName = userPermissions.reduce((groups, perm) => {
		if (perm.includes(groupName)) {
			groups.push(perm);
		}
		return groups;
	}, []);

	return (
		groupByName.length === 1 &&
		groupByName[0] === `${groupName}.${permission}`
	);
};

export const getDateTime = () => {
	const today = new Date();
	const date =
		today.getFullYear() +
		'-' +
		(today.getMonth() + 1) +
		'-' +
		today.getDate();
	const time =
		today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
	const dateTime = date + ' ' + time;
	return dateTime;
};

/**
 * check if only the permission exists in the group
 * @param {*} originalObj
 * @param {*} modifiedObj
 * @returns
 */
export const processCreatePatch = (originalObj, modifiedObj) => {
	let keys = [];
	const pushKey = k => {
		if (!keys.includes(k)) {
			keys.push(k);
		}
	};
	for (const key in originalObj) {
		if (originalObj[key] instanceof Date) {
			pushKey(key);
			originalObj[key] = originalObj[key].toISOString();
		}
	}
	for (const key in modifiedObj) {
		if (modifiedObj[key] instanceof Date) {
			pushKey(key);
			modifiedObj[key] = modifiedObj[key].toISOString();
		}
	}
	let patchedObj = createPatch(originalObj, modifiedObj);
	if (keys.length) {
		keys.forEach(key => {
			patchedObj.forEach(element => {
				if (element.path.toString().split('/')[1] == key) {
					element.value = new Date(element.value);
				}
			});
		});
	}

	return patchedObj;
};

/**
 * check if a string has a word and an identifier followed.
 * @param {string} string
 * @param {string} word
 * @param {string, int} id
 * @returns
 */
export const containsWordAndId = (string, word, id) => {
	if (!id || !word) return false;
	id = typeof id === 'number' ? id.toString() : id;
	const escapeRegExp = string => {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	};
	var pattern = new RegExp(
		'\\b' + word + '\\b(?=\\D*\\b' + escapeRegExp(id) + '\\b)',
		'i'
	);
	return pattern.test(string);
};

/**
 * This function compares two objects and calculates the number of elements that are not equal, consider array empty and null as equal.
 * @param {obj} object1
 * @param {string} object2
 * @returns {number}
 */
export const countsDiffObjects = (object1, object2, excludeKeys = []) => {
	const keys = _.difference(
		_.union(_.keys(object1), _.keys(object2)),
		excludeKeys
	);
	let differences = 0;
	_.forEach(keys, key => {
		const value1 = object1[key];
		const value2 = object2[key];

		if (
			(_.isArray(value1) && _.isNull(value2)) ||
			(_.isArray(value2) && _.isNull(value1))
		) {
			// Consider [] and null as equals
			if (_.isEmpty(value1) || _.isNull(value1)) {
				// If the array is empty or null, consider it equal
				if (!_.isNull(value2)) {
					differences++;
				}
			} else if (_.isEmpty(value2) || _.isNull(value2)) {
				// If the array is empty or null, consider it equal
				if (!_.isNull(value1)) {
					differences++;
				}
			} else {
				// If the array is not empty or null, consider it different from null
				differences++;
			}
		} else if (!_.isEqual(value1, value2)) {
			// Compare other cases by default
			differences++;
		}
	});

	return differences;
};

/**
 * This function compares two objects and return the diferents between the original and the new.
 * @param {obj} originalObj
 * @param {obj} newObj
 * @returns {obj}
 */
export const getDifferentValues = (originalObj, newObj) => {
	const result = {};

	const compareObjects = (original, updated) => {
		for (const key in original) {
			if (
				Object.prototype.hasOwnProperty.call(original, key) &&
				Object.prototype.hasOwnProperty.call(updated, key)
			) {
				const originalValue = original[key];
				const updatedValue = updated[key];

				const newPath = key;

				if (
					typeof originalValue === 'boolean' &&
					typeof updatedValue === 'boolean' &&
					originalValue !== updatedValue
				) {
					result[newPath] = updatedValue;
				}

				if (
					typeof originalValue === 'object' &&
					typeof updatedValue === 'object'
				) {
					compareObjects(originalValue, updatedValue, newPath);
				}

				if (originalValue !== updatedValue && updatedValue) {
					result[newPath] = updatedValue;
				}
			}
		}
	};

	compareObjects(originalObj, newObj);

	return result;
};

/**
 * This function compares two array of objects with structure {text:'', value:''} and return if are equals.
 * @param {array} arr1
 * @param {array} arr2
 * @returns {boolean}
 */
export const compareArraysOfObjects = (arr1, arr2) => {
	if (arr1.length !== arr2.length) {
		return false;
	}
	const sortedArr1 = arr1
		.slice()
		.sort((a, b) => a.text.localeCompare(b.text));
	const sortedArr2 = arr2
		.slice()
		.sort((a, b) => a.text.localeCompare(b.text));
	for (let i = 0; i < sortedArr1.length; i++) {
		if (
			sortedArr1[i].text !== sortedArr2[i].text ||
			sortedArr1[i].value !== sortedArr2[i].value
		) {
			return false;
		}
	}

	return true;
};

/**
 * This function sort by property an array of options [{text:'', value:''},{text:'', value:''}].
 * @param {array} arr
 * @returns {array}
 */
export const sortArrayofOptionsByProperty = (arr, property='text') => {
	return arr.slice().sort((a, b) => {
		const textA = a[property].toUpperCase(); // Ignore upper and lowercase
		const textB = b[property].toUpperCase(); // Ignore upper and lowercase
		if (textA < textB) {
			return -1;
		}
		if (textA > textB) {
			return 1;
		}
		// names must be equal
		return 0;
	});
};
